import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {format} from 'date-fns';
import {v4 as uuidv4} from 'uuid';
import {
  getCommissionBreakupData,
  submitCommissionInvoiceDocument,
  submitCommissionInvoiceDetails,
} from '@ibibo/myaccount-reducer';
import CommissionBreakup from './CommissionBreakup/CommissionBreakup';
import EmptyInvoice from '../GstInvoice/EmptyInvoice/EmptyInvoice';
import GstDetails from './GstDetails/GstDetails';
import InvoicePeriod from '../GstInvoice/InvoicePeriod/InvoicePeriod';
import {
  commissionBreakupData,
  gstInvoiceData,
  submissionErrorData,
} from '../GstInvoice/ClaimGstModal/mockData';
import {DownloadButton} from '../../../common/Form/Button/Button';
import SubmissionError from './SubmissionError/SubmissionError';
import Checkbox from '../../../../../../../onboarding/src/stories/components/OnboardingNew/GccComponents/CheckBox/CheckBox';
import Modal from '../../../common/Modal/Modal';
import SubmitSuccess from './SubmitSuccess/SubmitSuccess';
import Info from './Info/Info';
import Table from '../../../common/Table/Table';
import Uploader from '../../../common/UploaderWithPreview/Uploader';
import PdfViewer from '../../../common/PdfViewer/PdfViewer';
import noInvoicePng from '../../../RefundRaiseRequest/assets/no-request.png';
import Spinner from '../../../../../../../onboarding/src/stories/components/OnboardingNew/CommonComponents/Spinner/Spinner';
import CreditMemo from './CreditMemo/CreditMemo';
import {logPageLoadEvents, logOmniClick} from '@ibibo/analytics';
import {userSelector} from '@ibibo/user-reducer';
import {getCookie} from './../../../../../utils/getCookie';

const gstFormInitialState = {
  gstInvoiecNumber: '',
  gstInvoiceDate: format(new Date(), 'yyyy-MM-dd'),
  remarks: '',
};

const validRegex = /[^a-zA-Z0-9-_\/]/g;

const SubmitGSTInput = ({setMenuToTrackPage, sendTrackingDataToSdk}) => {
  const dispatch = useDispatch();

  const [pdfModal, setPdfModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [pdfPath, setPdfPath] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const [gstModal, setGsModal] = useState(null);
  const [data, setData] = useState(null);
  const [submitGstDetails, setSubmitGstDetails] = useState(false);
  const [gstForm, setGstForm] = useState(gstFormInitialState);
  const [gstFormValidFlag, setGstFormValidFlag] = useState(false);
  const [fileApproveResponseData, setFileApproveResponseData] = useState(null);
  const [disableSubmitGstInput, setDisableSubmitGstInput] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showSubmitLoader, setShowSubmitLoader] = useState(false);
  const [submitResponse, setSubmitResponse] = useState({});
  const [gstCheckboxAccepted, setGstCheckboxAccepted] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [gstError, setGstError] = useState({
    invalidDate: {
      flag: false,
      message: '',
    },
  });
  const [monthChangeFromTable, setMonthChangeFromTable] = useState(false);
  const [dateSelectionFromTable, setDateSelectionFromTable] = useState({});
  const [creditMemoFile, setCreditMemoFile] = useState({
    credit_memo_file_path: '',
    credit_memo_file: '',
  });
  const [pdfFilePath, setPdfFilePath] = useState('');
  const [creditMemoData, setCreditMemoData] = useState({
    credit_memo_number: '',
    credit_memo_date: format(new Date(), 'yyyy-MM-dd'),
    flights_commission: '',
    hotels_commission: '',
    wallet_commission: '',
  });

  const userInfoSelector = useSelector(userSelector);

  useEffect(() => {
    const {userInfo = {}} = userInfoSelector || {};
    const {account_id = ''} = userInfo;
    const ccdeCookie = getCookie('ccde');
    const isGCC = ccdeCookie == 'AE';
    logPageLoadEvents('reports:mysettings', {
      eVar15: `myPartner_gstSubmit|mypartner`,
      eVar67: `${account_id || ''}`, //mypartner agent id
      prop27: '/agent/gstinvoice/',
      eVar37: isGCC
        ? 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng'
        : 'domain_sbu:mypartner|domain_country:india|domain_currency:inr|domain_language:eng',
    });
  }, []);

  useEffect(() => {
    let flag = true;
    for (const row in gstForm) {
      if (row !== 'remarks' && !gstForm[row]) {
        flag = false;
      }
    }

    setGstFormValidFlag(flag);
  }, [gstForm]);

  const handleGstFormChange = (value, key) => {
    const cacheGstObject = gstForm;
    cacheGstObject[key] = value;
    setGstForm({...cacheGstObject});
  };

  const submitGst = () => {
    //setGsModal(!gstModal);
    setShowSubmitLoader(true);
    let objectToSubmit = {
      ...selectedDate,
      invoice: pdfFile,
      invoice_date: gstForm?.gstInvoiceDate,
      invoice_number: gstForm?.gstInvoiecNumber,
      remarks: gstForm?.remarks,
    };
    if (creditMemoData?.credit_memo_number) {
      if (data?.creditMemoData?.show_form) {
        for (const i in creditMemoData) {
          if (i != 'credit_memo_file_path' && creditMemoData[i])
            objectToSubmit[i] = creditMemoData[i];
        }
        for (const i in creditMemoFile) {
          if (i != 'credit_memo_file_path') objectToSubmit[i] = creditMemoFile[i];
        }
      } else {
        for (const i in creditMemoData) {
          if (i != 'flights_commission' && i != 'hotels_commission' && i != 'wallet_commission')
            objectToSubmit[i] = creditMemoData[i];
        }
        for (const i in creditMemoFile) {
          if (i != 'credit_memo_file_path') objectToSubmit[i] = creditMemoFile[i];
        }
      }
    }
    dispatch(
      submitCommissionInvoiceDetails(
        objectToSubmit,
        submitCommissionInvoiceDetailsSuccessCallback,
        submitCommissionInvoiceDetailsErrorCallback,
      ),
    );
    sendTrackingDataToSdk?.(
      {
        event_detail: {
          event_name: 'click',
          event_type: 'user_action',
          event_value: 'Submit Invoice Clicked',
        },
      },
      'GST_INVOICE_REPORT',
    );
  };

  const closeSubmitGstModal = () => {
    setGsModal(false);
    setMenuToTrackPage && setMenuToTrackPage();
  };

  const getUploadedFile = file => {
    setPdfModal(true);
    setPdfPath(file[0].preview);
    setPdfFile(file[0]);
    setPdfFilePath('VIEW_INVOICE');
  };

  const handleViewInvoice = () => {
    setPdfModal(!pdfModal);
    setPdfFilePath('VIEW_INVOICE');
  };

  const getCommissionData = (dateObject, resubmit = false, bolt_rejected = false) => {
    setSelectedDate(dateObject);
    setDateSelectionFromTable({
      startDate: dateObject?.start_date,
      endDate: dateObject?.end_date,
      customSelection: 'custom',
    });
    setMonthChangeFromTable(true);
    dispatch(
      getCommissionBreakupData(
        dateObject,
        (resubmit = resubmit),
        bolt_rejected,
        getCommissionDataSuccessCallback,
        getCommsionBreakupErrorCallback,
      ),
    );
  };

  const getCommissionDataSuccessCallback = resp => {
    setData(resp?.data);
    setMonthChangeFromTable(false);
    setFileApproveResponseData([]);
    setFileApproveResponseData(null);
    setGstForm({...gstFormInitialState});
  };

  const getCommsionBreakupErrorCallback = err => {
    setData(null);
    const obj = gstError;
    obj.invalidDate.message = err.message;
    obj.invalidDate.flag = true;
    setGstError({...obj});
    setMonthChangeFromTable(false);
    setFileApproveResponseData([]);
    setFileApproveResponseData(null);
  };

  const resetData = () => {
    setData(null);
  };

  const approveInvoicePdf = () => {
    setShowLoader(true);
    dispatch(
      submitCommissionInvoiceDocument(
        {
          ...selectedDate,
          invoice: pdfFile,
          invoice_date: gstForm?.gstInvoiceDate,
          invoice_number: gstForm?.gstInvoiecNumber,
        },
        approveInvoicePdfSuccessCallback,
        approveInvoicePdfErrorCallback,
      ),
    );
  };

  const approveInvoicePdfSuccessCallback = resp => {
    setShowLoader(false);
    setFileApproveResponseData(resp);
    setPdfModal(false);
    setDisableSubmitGstInput(true);
    setGstFormValidFlag(true);
    setGstCheckboxAccepted(resp?.ocr_pass);
  };

  const approveInvoicePdfErrorCallback = err => {
    setShowLoader(false);
    setErrorMsg(err?.message || 'Something went wrong. Please try again.');
    console.log(err);
  };

  const submitCommissionInvoiceDetailsSuccessCallback = resp => {
    setGsModal(gstModal => !gstModal);
    setShowSubmitLoader(false);
    setSubmitResponse(resp);
  };

  const submitCommissionInvoiceDetailsErrorCallback = err => {
    setSubmitResponse(err);
    setShowSubmitLoader(false);
    setGsModal(gstModal => !gstModal);
  };

  const clearGstFormData = () => {
    // setGstForm({
    //   gstInvoiecNumber: '',
    //   gstInvoiceDate: '',
    //   remarks: '',
    // });
    setDisableSubmitGstInput(false);
    // setGstFormValidFlag(false); //reduntant
    setFileApproveResponseData(null);
  };

  const uploadCreditMemoFile = file => {
    const fileData = {
      credit_memo_file_path: file[0].preview,
      credit_memo_file: file[0],
    };
    setCreditMemoFile({...fileData});
  };

  const clearCreditMemoFile = () => {
    setCreditMemoFile({...creditMemoFile, credit_memo_file: ''});
  };

  const handleViewCreditMemo = () => {
    setPdfModal(pdfModal => !pdfModal);
    setPdfFilePath('VIEW_CREDIT_MEMO');
  };

  const checkForCreditMemoData = () => {
    if (data?.creditMemoData?.show_form) {
      for (const i in creditMemoData) {
        if (creditMemoData[i] === '') return false;
      }
    } else {
      for (const i in creditMemoData) {
        if (i != 'flights_commission' && i != 'hotels_commission' && i != 'wallet_commission')
          if (creditMemoData[i] === '') return false;
      }
    }
    for (const i in creditMemoFile) {
      if (creditMemoFile[i] === '') return false;
    }
    return true;
  };

  return (
    <React.Fragment>
      <InvoicePeriod
        getGstDataCaller={getCommissionData}
        dateObject={dateSelectionFromTable}
        isMonthChangeFromTable={monthChangeFromTable}
        startdateString={'2025-04-01'}
        resetData={resetData}
      />
      {data !== null && data?.submissionOverlap === true && (
        <Info text={data?.heading} inline={true} width="auto" />
      )}
      {data !== null && data?.creditMemoData && (
        <>
          <CreditMemo
            creditMemo={data?.creditMemoData}
            dateObject={selectedDate}
            setCreditMemoData={setCreditMemoData}
            creditMemoData={creditMemoData}
          />
          <div className="mt10"></div>
          <Uploader
            getUploadedFile={uploadCreditMemoFile}
            gstFormValidFlag={true}
            viewInvoice={handleViewCreditMemo}
            clearGstFormData={clearCreditMemoFile}
            heading={'Upload your Credit Memo'}
            viewButtonMessage={'view memo'}
            subHeading={
              'For faster approval and credit of the due GST amount use the credit memo generated on myPartner'
            }
            additionalInfo={'(Credit Memo without signature & company stamp will be rejected)'}
          />
        </>
      )}
      {data !== null && data?.submissionOverlap === false && (
        <div className="mt30">
          <CommissionBreakup {...commissionBreakupData} breakupData={data} />
        </div>
      )}

      {data !== null && data?.submissionOverlap === false && (
        <div className="mt30">
          <GstDetails
            gstForm={gstForm}
            handleGstFormChange={handleGstFormChange}
            disableSubmitGstInput={disableSubmitGstInput}
            regexPattern={validRegex}
          />
        </div>
      )}

      {data !== null && data?.submissionOverlap == false && (
        <div className="mt30" style={{pointerEvents: gstFormValidFlag ? '' : 'none'}}>
          <Uploader
            getUploadedFile={getUploadedFile}
            gstFormValidFlag={gstFormValidFlag}
            viewInvoice={handleViewInvoice}
            clearGstFormData={clearGstFormData}
          />
        </div>
      )}
      {data !== null && data?.submissionOverlap === true && (
        <div className="mt30">
          <Table
            data={gstInvoiceData}
            tableData={data?.month_view}
            getCommissionData={getCommissionData}
          />
        </div>
      )}
      {data === null && (
        <div className="mt30">
          <EmptyInvoice
            icon={noInvoicePng}
            description={
              gstError.invalidDate.flag
                ? gstError.invalidDate.message
                : 'You haven’t generated any invoice so far! <Span>Select your Period/Month to download invoices</span>.'
            }
          />
        </div>
      )}
      {fileApproveResponseData && fileApproveResponseData?.ocr_errros?.errors?.length && (
        <div className="mt20">
          <SubmissionError {...fileApproveResponseData?.ocr_errros} />
        </div>
      )}
      {!fileApproveResponseData?.ocr_errros?.invalid_invoice_number &&
        fileApproveResponseData &&
        gstFormValidFlag &&
        fileApproveResponseData?.ocr_errros?.errors?.length && (
          <div className="mt20">
            <Checkbox
              id={uuidv4()}
              onChange={e => setGstCheckboxAccepted(gstCheckboxAccepted => !gstCheckboxAccepted)}
            >
              <p className="fs12 latoRegular blackText mt3">
                I understand that if certain fields are not accurately filled out, my GST credit
                application may be delayed or rejected.
              </p>
            </Checkbox>
          </div>
        )}
      {fileApproveResponseData && gstFormValidFlag && (
        <div className="mt30">
          {showSubmitLoader ? (
            <Spinner width="32px" height="32px" borderWidth="4px" />
          ) : (
            <DownloadButton
              onClick={submitGst}
              isActive={
                fileApproveResponseData?.ocr_pass
                  ? gstFormValidFlag
                  : data?.creditMemoData
                  ? gstFormValidFlag && gstCheckboxAccepted && checkForCreditMemoData()
                  : gstFormValidFlag && gstCheckboxAccepted
              }
              disabled={
                fileApproveResponseData?.ocr_pass
                  ? !gstFormValidFlag
                  : data?.creditMemoData
                  ? !gstFormValidFlag || !checkForCreditMemoData() || !gstCheckboxAccepted
                  : !gstFormValidFlag || !gstCheckboxAccepted
              }
            >
              Submit GST Invoice
            </DownloadButton>
          )}
        </div>
      )}
      {gstModal && (
        <Modal onClose={closeSubmitGstModal}>
          <SubmitSuccess
            icon={submitResponse?.showIcon}
            heading={submitResponse?.heading}
            subHeading={submitResponse?.subHeading}
          />
        </Modal>
      )}
      {pdfModal && (
        <Modal
          bgColor="#252525"
          width={'590px'}
          closeBtn={!showLoader}
          onClose={() => {
            setPdfModal(false);
            setPdfFile('');
          }}
        >
          {pdfFilePath === 'VIEW_INVOICE' ? (
            <PdfViewer
              pdfSrc={pdfPath}
              approveInvoicePdf={approveInvoicePdf}
              showLoader={showLoader}
              errorMsg={errorMsg}
              setErrorMsg={setErrorMsg}
            />
          ) : pdfFilePath === 'VIEW_CREDIT_MEMO' ? (
            <PdfViewer
              pdfSrc={creditMemoFile?.credit_memo_file_path}
              showContinue={false}
              showLoader={showLoader}
            />
          ) : (
            <></>
          )}
        </Modal>
      )}
    </React.Fragment>
  );
};

export default SubmitGSTInput;
